/*global define, require*/
/*jshint devel:true*/
/**
 * Beta! Module Model
 */
define(
	'BaseModuleModel',[
		'jquery',
		'backbone', // this returns the Backbone constructor
		'BaseModel',
		'BaseTransferModelCollection'
	],
	function ($, Backbone, BaseModel, BaseTransferModelCollection) {
		'use strict';

		//DEBUG
		//console.log('Call Settings config model');

		// Common vars
		var serviceDataListAttrName = 'serviceDataList';

		return BaseModel.extend(
			{
				/**
				 * Name of the current class. Used to build debug messages.
				 * @type {String}
				 */
				className: 'BaseModuleModel',

				/**
				 * Default model structure inspired from the portal data model.
				 * Unnecessary data model variables are commented out.
				 */
				defaults: {
					/**
					 * Content model that represents the CMS contents.
					 * @see Example of data model in /vault/yellowSubmarine/mocks/callSettings/callSettings.json:10
					 * @type {Backbone.Model}
					 */
					contentModel: null,
					/**
					 * Reference to the portal controller's model
					 * @type {BaseModel}
					 */
					controllerModel: null,
					/**
					 * Reference to the service model collection
					 * @type {BaseTransferModelCollection}
					 */
					serviceDataList: null
				}, // end of defaults

				/**
				 * Basic model validation
				 * No common validation yet
				 */
				// validation: null,

				/**
				 * Automatically fetch data from the internal collection of BaseTransferModels at initialisation time
				 * Default value is true.
				 * @type {Boolean}
				 */
				autoPostload: true,

				/**
				 * Init the BaseModuleModel object
				 */
				initialize: function () {
					var self = this,
						methodName = 'initialize';

					// call parent method
					BaseModel.prototype.initialize.apply(self, [].slice.call(arguments));

					self.alwaysCoerceAttrToModel(
						serviceDataListAttrName,
						BaseTransferModelCollection // coerce this attribute to BaseTransferModelCollection
					);

					self.alwaysCoerceAttrToModel(
						'controllerModel',
						BaseModel // coerce this attribute to BaseModel
					);

					self.alwaysCoerceAttrToModel(
						'contentModel',
						BaseModel // coerce this attribute to BaseModel
					);

					if (self.autoPostload) {
						self.fetchServiceData();
					}

					//DEBUG
					//window.sponge = self;
				}, // end of initialize: function ()

				/**
				 * Fetch data for each item of the serviceDataList
				 * This will also make sure that the 'controllerModel' attribute from the remote server (TransactionModel)
				 * is merged onto our module model's controllerModel attribute
				 * @returns {*}
				 */
				fetchServiceData: function () {
					var self = this,
						controllerModelAttrName = 'controllerModel';

					// call fetch() on all items of this collection
					self.get(serviceDataListAttrName).fetchItems({
						// only fetch items marked for postload
						filter: {
							status: 'postload'
						},
						success: function (transferModel, jsonData, jqXhr) {
							//DEBUG
							//console.log('fetchServiceData: success: arguments = ', arguments);
							//console.log('curModel JSON = ', JSON.stringify(transferModel));

							// retrieve the controller model attribute's raw value
							var transferredRawControllerModel = jsonData && jsonData[controllerModelAttrName];
							if (transferredRawControllerModel) { // if it exists, set it on the BaseModuleModel directly
								self.set(controllerModelAttrName, transferredRawControllerModel);
							}

							// in any case, remove it from our BaseTransferModel
							transferModel.unset(controllerModelAttrName);
							jsonData[controllerModelAttrName] = undefined;
							delete jsonData[controllerModelAttrName];

							//DEBUG
							//console.log('AFTER fetchServiceData: success: arguments = ', arguments);
							//console.log('AFTER curModel JSON = ', JSON.stringify(transferModel));
						}
					});
					return self;
				},

				/**
				 * Returns the BaseTransferModel contained within the module's service data list, with a given id.
				 * @param {String} [serviceId] Service Id. If no serviceId is given, it'll return the first BaseTransferModel object in the service data list.
				 * @return {BaseTransferModel}
				 */
				getServiceWrapperModel: function (serviceId) {
					var self = this,
						methodName = 'getServiceWrapperModel',
						serviceDataList = self.get('serviceDataList'),
						ret;

					if (serviceDataList) {
						if (typeof serviceId !== 'undefined') { // get the object with id = serviceId
							ret = serviceDataList.where({id: serviceId})[0];
						} else { // or return the first one in the collection
							ret = serviceDataList.at(0);
						}
					}

					//if (!ret) {
					//	throw new Error(self.report(methodName, 'unable to find service wrapper model for id=' + serviceId));
					//}

					return ret;
				},

				/**
				 * Returns ServiceModel contained within the BaseTransferModel object of a given service id.
				 * @param {String} [serviceId] Service Id. If no serviceId is given, it'll return the first BaseTransferModel object in the service data list.
				 * @return {ServiceModel}
				 */
				getServiceModel: function (serviceId) {
					var self = this,
						methodName = 'getServiceModel',
						serviceWrapperModel = self.getServiceWrapperModel(serviceId);

					if (!serviceWrapperModel) {
						throw new Error(self.report(methodName, 'unable to find service model. serviceId=' + serviceId));
					}

					return serviceWrapperModel.data();
				}
			}
		);
	}
);
